/**
 * The `serializeQuery` function serializes an object of filters into a format suitable for query string generation.
 * @param {Object} filters - The object containing keys and values to serialize.
 * @returns {Object} - A serialized object where each key-value pair is in a format ready for query string conversion.
 */
const serializeQuery = (filters) => {
  const serialized = {} // Initialize the serialized result object.

  // Iterate over each key in the filters object.
  Object.keys(filters).forEach((key) => {
    const value = filters[key] // Get the value associated with the key.

    if (Array.isArray(value)) {
      // If the value is an array.
      value.forEach((item, index) => {
        if (typeof item === 'object' && item !== null) {
          // If the array item is an object — use numeric index to preserve structure per item.
          Object.keys(item).forEach((subKey) => {
            const subValue = item[subKey]
            const subKeyFull = `${key}[${index}][${subKey}]`
            serialized[subKeyFull] = subValue
          })
        } else {
          // If the array item is not an object.
          const keyArray = `${key}[]` // Create the array key.

          // Check if the array key is already in the serialized object.
          if (!Object.prototype.hasOwnProperty.call(serialized, keyArray)) {
            serialized[keyArray] = [] // Initialize it as an array if it doesn't exist.
          }
          serialized[keyArray].push(item) // Push the item to the array.
        }
      })
    } else if (typeof value === 'object' && value !== null) {
      // If the value is an object.
      Object.keys(value).forEach((subKey) => {
        const subValue = value[subKey]
        serialized[`${key}[${subKey}]`] = subValue // Add the sub-key and sub-value to the serialized object.
      })
    } else {
      // For all other types (string, number, etc.).
      serialized[key] = value // Directly add the key-value pair to the serialized object.
    }
  })

  return serialized // Return the serialized object.
}

export default serializeQuery
